// Firebase Messaging - Lazy loading with browser support detection
// This enables proper tree-shaking and checks for messaging support

import { getMessaging } from 'firebase/messaging';
import app from '../firebase.js';

// Singleton instance for Messaging - lazy initialization with support check
let messagingInstance = null;

/**
 * Get Firebase Messaging instance (singleton pattern)
 * Only initializes once after checking browser support
 * Returns null if messaging is not supported in current environment
 */
export const messaging = async () => {
  if (!messagingInstance) {
    try {
      // Check if messaging is supported in current browser/environment
      const { isSupported } = await import('firebase/messaging');
      if (await isSupported()) {
        messagingInstance = getMessaging(app);
      } else {
        console.warn('Firebase Messaging is not supported in this browser');
        return null;
      }
    } catch (error) {
      console.warn('Firebase Messaging initialization failed:', error);
      return null;
    }
  }
  return messagingInstance;
};

// Re-export all Firebase Messaging methods for convenience
// This maintains the same API as before but with lazy loading
export {
  getToken,
  onMessage,
  deleteToken
} from 'firebase/messaging';

/**
 * Convenience function to get messaging instance and common methods together
 * Usage: const { messagingInstance, getToken, onMessage } = await getMessagingBundle();
 */
export const getMessagingBundle = () => {
  return import('firebase/messaging').then(async (messagingModule) => ({
    messaging: await messaging(),
    ...messagingModule
  }));
};
